import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError, isAxiosError } from "axios";
import api from "src/http/index";

import { ErrorResponse } from "src/types/error-response.type";
import { ClientsResponse, ClientsResponseLength } from "src/types/request.type";
import { SuccessResponse } from "src/types/success-response.type";


export const clientsData = createAsyncThunk<ClientsResponseLength, void>(
  "/clientsData",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    console.log("===================================")


    try {
      // configure header's Content-Type as JSON

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        params: {         
          page: 1,
          qtyPerPage: 1000
        },

      };

      const response = await api.get(`/clients`, config);

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);



export const clientsDataPage = createAsyncThunk<ClientsResponseLength, {}>(
  "/clientsDataPage",
  async (obj, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    console.log("===================================")

    var page = Number(Object.values(obj)[0]) + 1;
    var qtyPerPage = Object.values(obj)[1];

    console.log(page +  "   " + qtyPerPage );

    try {
      // configure header's Content-Type as JSON

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        params: {         
          page: page,
          qtyPerPage: qtyPerPage
        },

      };

      const response = await api.get(`/clients`, config);


      console.log(response);

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);





export const clientsDataUpdate = createAsyncThunk<
  ClientsResponse,
  ClientsResponse
>(
  "/clientsDataUpdate",
  async (client, { rejectWithValue, fulfillWithValue }) => {
    // //data
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const databody = {
        title: client.title, // This is the body part
      };

      const response = await api.patch(
        `/clients/${client.id}`,
        databody,
        config
      );

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);

export const clientsDataDelete = createAsyncThunk<
  SuccessResponse,
  ClientsResponse
>(
  "/clientsDataDelete",
  async (client, { rejectWithValue, fulfillWithValue }) => {
    // //data
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const databody = {
        title: client.title, // This is the body part
      };

      const response = await api.delete(
        `/clients/${client.id}`,
        config
      );

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);

export const clientsDataInsert = createAsyncThunk<
  SuccessResponse,
  string | undefined | null
>(
  "/clientsDataInsert",
  async (clientid, { rejectWithValue, fulfillWithValue }) => {
    // //data
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    //console.log(clientid);

    if (clientid === null || typeof clientid === "undefined") {
      return rejectWithValue("Request ERROR");
    }

    try {

      // configure header's Content-Type as JSON
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const databody = {
        title: clientid, // This is the body part
      };

      const response = await api.post(
        `/clients`,
        databody,
        config
      );

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);


export const dataUpload = createAsyncThunk<
  SuccessResponse,
  FormData
>(
  "/dataUpload",
  async (formData, { rejectWithValue, fulfillWithValue }) => {
    // //data

    console.log("xxxxxxxxxxxxxxxx");
    
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    console.log(formData);

    if (formData === null || typeof formData === "undefined") {
      return rejectWithValue("Request ERROR");
    }

    try {

      // configure header's Content-Type as JSON
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };


console.log(formData.entries())

     // const databody = {
     //   file: Object.fromEntries(formData.entries()), // This is the body part
     // };

    const databody = Object.fromEntries(formData.entries());

      const response = await api.post(
        `/repair-requests/upload-file`,
        databody,
        config
      );

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);


